import React, { Component } from "react";
import { NavLink, Switch } from "react-router-dom";
import ReactDOM from "react-dom";

export default class SubNavigation extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {}
	componentWillUnmount() {}

	componentDidUpdate(prevProps) {
		if (prevProps.location.hash !== this.props.location.hash) {
			let hash = this.props.location.hash.replace("#", "");

			if (hash) {
				let node = ReactDOM.findDOMNode(this.props.refs[hash]);

				if (node) {
					node.scrollIntoView({
						block: "center",
						behavior: "smooth",
						inline: "nearest"
					});
				}
			}
		}
	}

	render() {
		const { navItems } = this.props;
		return (
			<div className="sub-navigation position-sticky sticky-top w-100">
				<div className="container">
				<ul className="d-flex justify-content-between align-items-center mb-0 p-0">
					{typeof navItems !== "undefined" && navItems.length
						? navItems.map((item, x) => {
								let delay = ((x + 1) * 50) / 100;
								return (
									<li key={item.id} style={{ transitionDelay: `${delay}s` }}>
										<NavLink
											to={{ hash: item.id }}
											className="nav-link text-center">
											{item.title}
										</NavLink>
									</li>
								);
						  })
						: ""}
				</ul>
				</div>
			</div>
		);
	}
}
